// Browser-side decryptor for aymanediary exports - runs entirely offline
// (Web Crypto API), no server round-trip. Mirrors the container format and
// KDF parameters in ovThinker-API's utils/exportCrypto.js exactly:
// MAGIC(4) + salt(16) + iv(12) + ciphertext+authTag. ITERATIONS must match
// the backend or nothing will decrypt.
const MAGIC = [0x41, 0x44, 0x58, 0x31]; // "ADX1"
const SALT_LENGTH = 16;
const IV_LENGTH = 12;
const ITERATIONS = 210000;

async function deriveKey(passphrase, salt) {
  const baseKey = await window.crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(passphrase),
    "PBKDF2",
    false,
    ["deriveKey"]
  );
  return window.crypto.subtle.deriveKey(
    { name: "PBKDF2", salt, iterations: ITERATIONS, hash: "SHA-256" },
    baseKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["decrypt"]
  );
}

async function gunzip(arrayBuffer) {
  const stream = new Blob([arrayBuffer])
    .stream()
    .pipeThrough(new window.DecompressionStream("gzip"));
  return new Response(stream).text();
}

export async function decryptExportFile(arrayBuffer, passphrase) {
  const bytes = new Uint8Array(arrayBuffer);
  const magicOk = MAGIC.every((b, i) => bytes[i] === b);
  if (!magicOk) throw new Error("Unrecognized export file format.");

  let offset = MAGIC.length;
  const salt = bytes.slice(offset, offset + SALT_LENGTH);
  offset += SALT_LENGTH;
  const iv = bytes.slice(offset, offset + IV_LENGTH);
  offset += IV_LENGTH;
  const ciphertextAndTag = bytes.slice(offset);

  const key = await deriveKey(passphrase, salt);
  const plaintextGzipped = await window.crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    key,
    ciphertextAndTag
  );

  const json = await gunzip(plaintextGzipped);
  return JSON.parse(json);
}
